import { createContext } from "react";

const AttenInputContext = createContext();

export default AttenInputContext;
